import { Box,Typography } from '@mui/material'
import React from 'react'
import { theme } from '../../styles/theme'

export default function OrganisationBadge({ status,admin }) {

    if(admin){
        if (!status ) {
            return (<Box style={{ width : "fit-content", display: "flex", alignItems  : "center", gap : 2, padding: "2px 8px", borderRadius: "14px", backgroundColor: theme.statusSuccessAlpha, color: theme.statusSuccess }}>
            <Box height="8px" width="8px" borderRadius="50px" bgcolor={theme.statusSuccess} ></Box>
            <Typography fontWeight="bold" variant="caption" ml={0.2}>Active</Typography> 
            </Box>)
        } else {
            return <Box style={{width : "fit-content", display: "flex", alignItems  : "center", gap : 2, padding: "2px 8px", borderRadius: "14px", backgroundColor: theme.col_2_alpha, color: theme.statusDisabled }}>
            <Box height="8px" width="8px"  borderRadius="50px" bgcolor={theme.col_2}></Box>
            <Typography fontWeight="bold" variant="caption" color={theme.col_2} ml={0.2}>{admin ? 'Inactive' :"Inactive"}</Typography> 
            </Box>
          
        } 
    }
    else{

        if (status ) {
            return (<Box style={{ width : "fit-content", display: "flex", alignItems  : "center", gap : 2, padding: "2px 8px", borderRadius: "14px", backgroundColor: theme.statusSuccessAlpha, color: theme.statusSuccess }}>
            <Box height="8px" width="8px" borderRadius="50px" bgcolor={theme.statusSuccess} ></Box>
            <Typography fontWeight="bold" variant="caption" ml={0.2}>Active</Typography> 
            </Box>)
        } else {
            return <Box style={{width : "fit-content", display: "flex", alignItems  : "center", gap : 2, padding: "2px 8px", borderRadius: "14px", backgroundColor: theme.col_2_alpha, color: theme.statusDisabled }}>
            <Box height="8px" width="8px"  borderRadius="50px" bgcolor={theme.col_2}></Box>
            <Typography fontWeight="bold" variant="caption" color={theme.col_2} ml={0.2}>{admin ? 'Inactive' :"Inactive"}</Typography> 
            </Box>
          
        }
    }

}
